var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('el-carousel',{staticStyle:{"border-radius":"0 0 10px 10px"},attrs:{"height":_vm.bannerHeight + 'px'}},_vm._l((_vm.imgList),function(item){return _c('el-carousel-item',{key:item.id},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":item.banner}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }